import { render, staticRenderFns } from "./section-proyectos.vue?vue&type=template&id=78157153&scoped=true"
import script from "./section-proyectos.vue?vue&type=script&lang=js"
export * from "./section-proyectos.vue?vue&type=script&lang=js"
import style0 from "./section-proyectos.vue?vue&type=style&index=0&id=78157153&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78157153",
  null
  
)

export default component.exports